module.exports = __webpack_public_path__ + "img/home-about-考前突击密训.0922626d.png";